// @flow

type StyleObject = $Shape<CSSStyleDeclaration>;

/**
 * @param element - the target HTML element
 * @param styles - CSS styles to add
 */
export const addStyle = (element: HTMLElement, styles: StyleObject) => {
    for (const style in styles) {
        // $FlowFixMe TODO: Waiting to fix css properties of the Flow Type
        element.style[style] = styles[style];
    }
};
